"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONFIG_PANEL_INNER_WIDTH = void 0;
// (C) 2022 GoodData Corporation
// TODO move somewhere to share with insight panel?
exports.CONFIG_PANEL_INNER_WIDTH = 204; // must match `$gd-configuration-panel-inner-width`
//# sourceMappingURL=constants.js.map